import React, { useEffect } from 'react';
import './Modal.css';

export default function Modal({
  open,
  onClose,
  children,
  variant = '',
}) {
  useEffect(() => {
    if (!open) return;

    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow =
        previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      className={`wingit-modal-overlay${variant ? ` wingit-modal-overlay--${variant}` : ''}`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`wingit-modal${variant ? ` wingit-modal--${variant}` : ''}`}
      >
        <button
          type="button"
          onClick={onClose}
          className="wingit-modal__close"
          aria-label="Close"
        >
          ×
        </button>

        <div className={`wingit-modal__content${variant ? ` wingit-modal__content--${variant}` : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
}
